"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColorWithAlpha = void 0;

var tslib_1 = require("tslib");

var hex_rgb_1 = tslib_1.__importDefault(require("hex-rgb"));

function getColorWithAlpha(color, alpha) {
  var _a = hex_rgb_1.default(color),
      red = _a.red,
      blue = _a.blue,
      green = _a.green;

  return "rgba(" + red + ", " + green + ", " + blue + ", " + alpha + ")";
}

exports.getColorWithAlpha = getColorWithAlpha;